<template>
    <button ref="btn" data-toggle="tooltip" data-placement="bottom"  class="btn" :class="type" @click="click"><icon v-if="icon" :name="icon"></icon> <slot></slot></button>
</template>

<script>
    export default {
        name: "iconBtn",
        props: ["icon", "tooltip", "type"],
        data() {
            return {
            }
        },
        mounted() {
            $(this.$refs.btn).tooltip();
        },
        methods: {

            click() {
                this.$emit('click', click);
            }

        },
        components: {
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// IconBtn.vue?9adba392